module.exports = __webpack_public_path__ + "media/student_v2/assets/images/student-alert-checkbox-check-ec9836653679cec927dc7e0c6c9f4f2c.svg";